export default __webpack_public_path__ + "static/media/discover.42e5cc04.svg";